'use client';

import { GoogleAnalytics } from '@next/third-parties/google';
import { useCookieConsent } from '@/hooks/useCookieConsent';

/**
 * Google Analytics is injected by @next/third-parties, which emits a real
 * `<script src>` rather than the `type="text/plain"` placeholder Cookiebot's
 * manual blocking mode looks for. So it is gated here instead: the component
 * renders nothing at all until Cookiebot reports statistics consent.
 */
export function ConsentGatedGoogleAnalytics({ gaId }: { gaId: string }) {
  const { analytics: statisticsConsent } = useCookieConsent();

  if (!statisticsConsent) return null;

  return <GoogleAnalytics gaId={gaId} />;
}
